import { useEffect } from 'react';

/**
 * Fija --app-vvh / --app-vv-top al visualViewport.
 * El shell no se estira con gestos; el pull-to-refresh es custom en AppShell.
 */
export function useLockAppViewportHeight(): void {
  useEffect(() => {
    const root = document.documentElement;

    const sync = () => {
      const vv = window.visualViewport;
      const height = Math.round(vv?.height ?? window.innerHeight);
      const top = Math.round(vv?.offsetTop ?? 0);
      root.style.setProperty('--app-vvh', `${height}px`);
      root.style.setProperty('--app-vv-top', `${top}px`);
    };

    sync();
    const vv = window.visualViewport;
    vv?.addEventListener('resize', sync);
    vv?.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);

    return () => {
      vv?.removeEventListener('resize', sync);
      vv?.removeEventListener('scroll', sync);
      window.removeEventListener('resize', sync);
      window.removeEventListener('orientationchange', sync);
    };
  }, []);
}
